module.exports = __webpack_public_path__ + "img/3f9a500.png";